"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NavLinkContainer = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "NavLinkContainer",
  class: "pl-n1911fpb",
  vars: {
    "n1911fpb-0": [({
      invert
    }) => invert ? _intents.default.ux.boxHighContrast.foregroundColor : _intents.default.ux.box.foregroundColor]
  }
});

/**
 * NavLink Component.
 *
 * @param {Object} props React props
 * @param {String} props._name Link Tracking name
 * @param {String} props.href Anchor href
 * @param {String} props.title Anchor Title
 * @param {Boolean} props.active Link active state
 * @param {String} props.anchorId Anchor section id
 * @param {Boolean} props.invertLink Invert condition for the anchors
 * @param {Number} props.tabIndex Link tab index prop
 * @param {Function} props.scrollToAnchor Onclick event to scroll to anchor
 * @returns {React.ReactElement} NavLink Component
 * @public
 */

function NavLinkComponent({
  i,
  _name,
  href,
  title,
  active,
  anchorId,
  partial,
  invertLink,
  tabIndex,
  scrollToAnchor
}) {
  const ref = (0, _react.useRef)(null);
  _patternLibraryUtils.tracking.useTracking(ref);
  const trackingProps = _patternLibraryUtils.tracking.props(_name, true, false);
  return /*#__PURE__*/_react.default.createElement(NavLinkContainer, (0, _extends2.default)({
    ref: ref,
    "data-cy": "nav-link",
    key: i,
    href: anchorId ? '#' : href
  }, anchorId ? {
    'data-target': anchorId,
    'onClick': e => {
      scrollToAnchor(e);
    }
  } : {}, {
    "data-active": active,
    "data-partial": partial || (invertLink ? 'dark1' : ''),
    tabIndex: tabIndex
  }, trackingProps), title);
}
var _default = exports.default = NavLinkComponent;
NavLinkComponent.propTypes = {
  i: _propTypes.default.number,
  _name: _propTypes.default.string,
  href: _propTypes.default.string,
  title: _propTypes.default.string,
  active: _propTypes.default.bool,
  anchorId: _propTypes.default.string,
  invertLink: _propTypes.default.bool,
  partial: _propTypes.default.string,
  tabIndex: _propTypes.default.number,
  scrollToAnchor: _propTypes.default.func
};